import { Translatable } from '@app/types/translatable.type';

const OfferLetterStatusesDisplayOptions: { [key: string]: Translatable } = {
    pending: 'table.offer-status.pending',
    accepted: 'table.offer-status.accepted',
    expired: 'table.offer-status.expired',
    withdrawn: 'table.offer-status.withdrawn',
    declined: 'table.offer-status.declined',
    hired: 'table.offer-status.hired',
};

export { OfferLetterStatusesDisplayOptions };
